import { useLanguage } from '@/src/contexts';
import { getText } from '@/src/helpers';
import { Token } from '@/src/models';
import { TableHead, TableRow } from '@/src/ui-components';

type OrderbookHeaderProps = {
  baseToken: Token;
  quoteToken: Token;
};

export const OrderbookHeader = (_props: OrderbookHeaderProps) => {
  const { language } = useLanguage();

  return (
    <TableRow>
      <TableHead className="text-xs text-left">{getText(language, 'price')}</TableHead>
      <TableHead className="text-xs text-right">{getText(language, 'qty')}</TableHead>
      <TableHead className="text-xs text-right">{getText(language, 'total')}</TableHead>
    </TableRow>
  );
};
